import { render, staticRenderFns } from "./stainlessSteelFloor.vue?vue&type=template&id=84033944&scoped=true"
import script from "./stainlessSteelFloor.vue?vue&type=script&lang=js"
export * from "./stainlessSteelFloor.vue?vue&type=script&lang=js"
import style0 from "./stainlessSteelFloor.vue?vue&type=style&index=0&id=84033944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84033944",
  null
  
)

export default component.exports